import React from "react";
import GamePage from "./GamePage";

type GameDetailsProps = {
    game: string;
    tagColor: string;
    instructionIcons: React.ReactNode[];
    fallbackInstructionIcon?: React.ReactNode;
};

const GameDetails: React.FC<GameDetailsProps> = ({ game, tagColor, instructionIcons, fallbackInstructionIcon = instructionIcons[0] }) => (
    <GamePage
        game={game}
        tagColor={tagColor}
        instructionIcons={instructionIcons}
        fallbackInstructionIcon={fallbackInstructionIcon}
    />
);

export default GameDetails;
